import DefaultModal from "Components/Modal/DefaultModal";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Button, Input, ListGroup, ListGroupItem, Label } from "reactstrap";
import { useControlshermContext } from "../context/ControlshermContext";
import { useDeclineSubstitutor } from "Api/Coordinator/Gebruikers/PlanscreenView";

const initialData = [
	{ id: "no_answer", label: "Niet bereikbaar" },
	{ id: "no_response_mail_sms", label: "In afwachting reactie SMS/Mail" },
	{ id: "not_available", label: "Niet beschikbaar" },
	{ id: "call_rejected", label: "Verzoek geweigerd" },
	{ id: "call_additional_reason", label: "Overige reden" },
	{ id: "note", label: "Opmerking" },
];

export default function ContractModal() {
	const { isOpen, setIsOpen, gebruikerId, subsId } = useControlshermContext()
	const navigate = useNavigate();
	const data = initialData;

	const [note, setNote] = useState("");
	const [reason, setReason] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const {trigger: declineSubstitutor,isMutating} = useDeclineSubstitutor();
	
	const handleSubmit = () => {
		setIsLoading(true);
		setError(null)
		declineSubstitutor({
			data: {
				gebruikerId,
				subsId,
				reason,
				note
			}
		})
			.then((res) => {
				if (res.data && res.data.status) {
					setIsOpen(false);
					navigate('/verzoeken/overzicht');
				} else if (res.data.message) {
					setError(res.data.message)
				}
			})
			.catch((e) => {
				console.log(e);
				setError("Substitutor was not declined");
			})
			.finally(() => setIsLoading(false));
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	return (
		<DefaultModal
			modal={isOpen}
			header="Contactregistratie"
			headerColor={""}
			toggle={() => setIsOpen(false)}
			showFooterBtns={false}
			classes="modal-dialog__over feedback-modal-style planscreen__modal planscreen__modal--contract wc-500"
		>
			<ListGroup flush className="py-4 border-bottom">
				{data.map((item) => {
					return (
						<ListGroupItem key={item.id} className={`d-flex gap-3 p-0 bg-transparent`}>
							<div
								style={{ minWidth: "200px" }}
								className="py-2 d-flex gap-2 text-start"
							>
								<Label>{item.label}</Label>
							</div>
							{item.id == "note" ? (
								<div className="py-2">
									<Input
										type="textarea"
										value={note}
										onChange={(e) => setNote(e.target.value)}
									/>
								</div>
							) : (
								<div className="py-2 cursor-pointer">
									<Input
										type="radio"
										checked={item.id === reason}
										onChange={() => setReason(item.id)}
									/>
								</div>
							)}
						</ListGroupItem>
					);
				})}
			</ListGroup>
			<div className="mt-4 d-flex gap-5 justify-content-center">
				<Button
					outline
					className={`btn-outline-primary-blue`}
					onClick={handleSubmit}
					type="button"
					color="primary"
					disabled={isLoading}
				>
					Toepassen
				</Button>
				<Button
					outline
					className={`btn-outline-primary-blue`}
					onClick={handleClose}
					type="button"
					color="primary"
				>
					Annuleren
				</Button>
			</div>
		</DefaultModal>
	);
}
